<a href="https://www.planexware.com/" class="planex-logo" target="_blank" rel="noreferrer noopener" [class.planex-logo--inline]="inline">
  <img src="assets/planexware.new.svg" alt="Planexware" class="planex-logo__img" [ngStyle]="{ width: width, height: height }">
</a>
